const NAME = "ACTIONS";

export default NAME;
